"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ThreeColumns = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/ThreeColumns"));

// Generated by script, don't edit it please.
var ThreeColumns = (0, _createSvgIcon["default"])({
  as: _ThreeColumns["default"],
  ariaLabel: 'three columns',
  category: 'layout',
  displayName: 'ThreeColumns'
});
var _default = ThreeColumns;
exports["default"] = _default;
module.exports = exports.default;